import React, { Component } from 'react';
import { Card, Button, Table, Modal, message, Input } from 'antd';
import { reqGetClients, reqDelClient } from '../../../api';
import ShowRole from '../components/add';
import { PAGE_SIZE } from '../../../utils/constants';
import LinkButton from '../../../components/link-button';

export default class ClientHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clients: [],
      isShow: false,
      total: '',
      currentPage: 1,
    };
    this.columns = [
      {
        title: '序号',
        dataIndex: 'index',
        align: 'center',
        render: (text, record, index) => {
          const number =
            ((this.state.currentPage || 1) - 1) * PAGE_SIZE + (index + 1);
          return number;
        },
      },
      {
        title: 'app_id',
        dataIndex: 'app_id',
        align: 'center',
      },
      {
        title: '名称',
        dataIndex: 'client_name',
        align: 'center',
      },
      {
        title: '有效',
        dataIndex: 'state',
        render: state => (state === 'enabled' ? 'true' : 'false'),
        align: 'center',
      },
      {
        title: '操作',
        render: client => (
          <span>
            <LinkButton onClick={() => this.showDetail(client)}>详情</LinkButton>
            {/* <LinkButton style={{ color: 'red' }} onClick={() => this.deleteClient(client)}>删除</LinkButton> */}
          </span>
        ),
        align: 'center',
      },
    ];
  }

  getClients = async (pagination = 1, value) => {
    const data = {
      name: value,
      pageNumber: pagination,
      pageSize: PAGE_SIZE,
      desc: 'true',
      orderby: '_id desc',
    };
    const res = await reqGetClients(data);
    if (res.status === 200) {
      const { result, total } = res;
      this.setState({
        clients: result,
        total,
        currentPage: pagination,
      });
    }
  };

  deleteClient = client => {
    const { id, client_name } = client;
    Modal.confirm({
      content: `确定删除${client_name}吗？`,
      onOk: async () => {
        const result = await reqDelClient(id);
        if (result.status) {
          message.success('删除成功');
          this.setState({
            currentPage: 1,
          });
          this.getClients();
        } else {
          message.error('删除失败');
        }
      },
    });
  };

  cancelAdd = () => {
    this.form.resetFields();
    this.setState({
      isShow: false,
    });
  };

  showDetail = client => {
    this.props.history.push('/admin/client/detail', client);
  };

  handlePagination = pagination => {
    this.setState({
      currentPage: pagination,
    });
    this.getClients(pagination);
  };

  componentDidMount() {
    this.getClients();
  }

  render() {
    const { clients, isShow, total, currentPage } = this.state;

    const title = (
      <Button type="primary" onClick={() => this.setState({ isShow: true })}>
        新增客户端
      </Button>
    );

    const extra = (
      <Input.Search
        placeholder="查询客户端"
        onSearch={value => this.getClients(1, value)}
        enterButton
      />
    );

    return (
      <Card title={title} style={{ height: '100%' }} extra={extra}>
        <Table
          bordered
          rowKey="id"
          dataSource={clients}
          columns={this.columns}
          pagination={{
            showSizeChanger: false,
            defaultPageSize: 10,
            total,
            showTotal: total => {
              return `共 ${total} 条`;
            },
            onChange: this.handlePagination,
            current: currentPage,
          }}
        />
        <Modal
          title="添加客户端"
          open={isShow}
          width="800px"
          footer={null}
          centered
          onCancel={this.cancelAdd}
        >
          <ShowRole
            setForm={form => {
              this.form = form;
            }}
            cancelAdd={this.cancelAdd}
            getClients={this.getClients}
          />
        </Modal>
      </Card>
    );
  }
}
